import React from "react";
import { getConfig } from "@edx/frontend-platform";
import { Button, Card } from "@openedx/paragon";
import { injectIntl, intlShape } from "@edx/frontend-platform/i18n";
import { useSelector } from "react-redux";
import { sendTrackingLogEvent } from "@edx/frontend-platform/analytics";
import messages from "../messages";
import { useModel } from "../../../generic/model-store";
import CourseCompletionDonutChart from "../../progress-tab/course-completion/CompletionDonutChart";
import "./StartOfResumeCourseCard.scss";

const { LMS_BASE_URL, ENABLE_OUTLINE_COMPLETION_CHART } = getConfig();

const StartOrResumeCourseCard = ({ intl }) => {
  const { courseId } = useSelector((state) => state.courseHome);

  const { org, shortDescription, courseImageUrl } = useModel(
    "courseHomeMeta",
    courseId,
  );

  const eventProperties = {
    org_key: org,
    courserun_key: courseId,
  };

  const {
    resumeCourse: { hasVisitedCourse, url: resumeCourseUrl },
  } = useModel("outline", courseId);

  if (!resumeCourseUrl) {
    return null;
  }

  const logResumeCourseClick = () => {
    sendTrackingLogEvent("edx.course.home.resume_course.clicked", {
      ...eventProperties,
      event_type: hasVisitedCourse ? "resume" : "start",
      url: resumeCourseUrl,
    });
  };

  return (
    <Card
      className="mb-3 raised-card overflow-hidden shadow-none border border-light"
      data-testid="start-resume-card"
    >
      <div className="course-image-container d-none d-md-block">
        <img
          className="course-image"
          src={LMS_BASE_URL + courseImageUrl}
          alt={shortDescription}
        />
        {ENABLE_OUTLINE_COMPLETION_CHART && (
          <div className="course-completion-container">
            <CourseCompletionDonutChart />
          </div>
        )}
      </div>
      {/* <div className="course-title-container p-3">
        <h3>{hasVisitedCourse ? intl.formatMessage(messages.resumeBlurb) : intl.formatMessage(messages.startBlurb)}</h3>
      </div> */}
      {/* Footer is needed for internal vertical spacing to work out. If you can remove, be my guest */}
      {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
      <Card.Footer className="course-card-footer">
        <Button
          variant="brand"
          block
          href={resumeCourseUrl}
          onClick={() => logResumeCourseClick()}
        >
          {hasVisitedCourse
            ? intl.formatMessage(messages.resume)
            : intl.formatMessage(messages.start)}
        </Button>
      </Card.Footer>
    </Card>
  );
};

StartOrResumeCourseCard.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(StartOrResumeCourseCard);
